import { OutletListItem, OutletState } from '@ancon/wildcat-types'

import isAppAcceptingOnlyPreOrders from '../../app/utils/isAppAcceptingOnlyPreOrders'

export default function isOutletAcceptingOnlyPreOrdersWhenOpen(
  outlet: OutletListItem | null,
) {
  if (outlet) {
    const isOutletOpened = outlet.state === OutletState.Opened

    return isOutletOpened && isAppAcceptingOnlyPreOrders()
  }

  return false
}
